module.exports = __webpack_public_path__ + "static/media/other.92d59953.png";